/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Total_DebtInputs */

const vi_customer_total_debt = /** @type {(inputs: Customer_Total_DebtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng nợ`)
};

/**

* @param {Customer_Total_DebtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_total_debt = /** @type {((inputs?: Customer_Total_DebtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Total_DebtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_total_debt(inputs)
});